'use strict';

exports.__esModule = true;
exports.HAS_UNSAFE_METHODS = exports.IS_PRODUCTION = exports.BEAUTIFY_OPTIONS = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @constant {Object} BEAUTIFY_OPTIONS the options to pass to cssbeautify
 */
var BEAUTIFY_OPTIONS = exports.BEAUTIFY_OPTIONS = {
  autosemicolon: true,
  indent: '  '
};

/**
 * @constant {boolean} IS_PRODUCTION is the runtime in the production environment
 */
var IS_PRODUCTION = exports.IS_PRODUCTION = !!(typeof process !== 'undefined' && process && process.env && process.env.NODE_ENV === 'production');

var _React$version$split$ = _react2.default.version.split('.').slice(0, 2).map(Number),
    REACT_MAJOR_VERSION = _React$version$split$[0],
    REACT_MINOR_VERSION = _React$version$split$[1];

/**
 * @constant {boolean} HAS_UNSAFE_METHODS have lifecycle methods been prefixed with `UNSAFE_` in the React version
 */


var HAS_UNSAFE_METHODS = exports.HAS_UNSAFE_METHODS = REACT_MAJOR_VERSION > 16 || REACT_MAJOR_VERSION === 16 && REACT_MINOR_VERSION >= 3;